import {Component, ElementRef, OnInit, HostListener, ViewChild, Renderer2, EventEmitter} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Subject} from "rxjs";
import {GetClaimService} from "./services/get-claim.service";
import {ClaimDto} from "../../../auto-generated-server-dtos/adjuster/claim/claim-dto";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {UpdateModalComponent} from "./update-modal/update-modal.component";
import {SetUpdateForRepairCentreService} from "./services/set-update-for-repair-centre.service";
import {SetViewedService} from "./services/set-viewed.service";
import {RepairDto} from 'src/app/auto-generated-server-dtos/adjuster/claim/repairs/models/repair-dto';
import {environment} from "../../../../environments/environment";
import {AdjusterDto} from "../../../auto-generated-server-dtos/adjuster/claim/assign-to/adjuster-dto";

@Component({
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.css']
})
export class ClaimComponent implements OnInit {
  isStickyHeaderOpen = true;
  loading = false;
  claimDto: ClaimDto | null = null;
  assignedAdjuster: AdjusterDto | null = null;
  repairs: RepairDto[] = [];
  repairTotal = 0;
  pst = 0;
  gst = 0;
  subTotal = 0;
  total = 0;
  isLocked = false;
  claimId: number = 0;
  busyUpdatingRepairCentre = false;
  submitted = new EventEmitter<void>();
  refreshMessages = new Subject<void>();
  repairsUpdated: Subject<RepairDto[]> = new Subject();
  statusUpdatedEvent: EventEmitter<void> = new EventEmitter<void>();
  customerRecordMatch: boolean = false;

  @ViewChild('claimHeader') claimHeader!: ElementRef;
  @ViewChild('stickyHeader') stickyHeader!: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private claimService: GetClaimService,
    private renderer: Renderer2,
    private ngbModal: NgbModal,
    private setUpdateForRepairCentreService: SetUpdateForRepairCentreService,
    private setViewedService: SetViewedService
  ) {
    this.renderer.addClass(document.body, 'adjuster');
    this.renderer.addClass(document.body, 'claim');
    this.renderer.removeClass(document.body, 'claim-list');
  }

  ngOnInit(): void {
    this.loading = true;
    this.route.params.subscribe(params => {
      this.claimId = parseInt(params['claimId']);
      this.updateClaim();
    });
    this.setViewedService.SetViewed(this.claimId).subscribe();
  }

  private updateClaim(callback?: () => void) {
    this.claimService.GetClaim(this.claimId).subscribe(claimDto => {
      this.claimDto = claimDto;
      this.loading = false;
      this.setLockState();
      claimDto.preApprovalExplanation = claimDto.preApprovalExplanation!.replace(/\|/g, ": ");
      if (callback) callback();
    });
  }

  setLockState() {
  }

  setUpdateForRepairCentre() {
    this.busyUpdatingRepairCentre = true;
    this.setUpdateForRepairCentreService.SetUpdateForRepairCentre(this.claimId).subscribe(() => {
      this.busyUpdatingRepairCentre = false;
      this.refreshMessages.next();
      this.openClaimUpdateModal();
    });
  }

  setRepairTotal(repairTotal: number) {
    this.repairTotal = repairTotal;
  }

  openClaimUpdateModal() {
    const modalRef = this.ngbModal.open(UpdateModalComponent, {
      size: 'sm',
      backdrop: 'static'
    });
    modalRef.componentInstance.claimDto = this.claimDto;
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    this.expandCollapseStickyHeader(this.isStickyHeaderOpen);
  }

  updateRepairs($event: RepairDto[]) {
    this.repairs = $event;
    this.repairsUpdated.next($event);
  }

  receiveCustomerRecordMatch(isMatch: boolean) {
    this.customerRecordMatch = isMatch;
  }

  refreshClaim() {
    this.updateClaim();
  }

  onStickyHeaderStateChange(isOpen: boolean) {
    this.isStickyHeaderOpen = isOpen;
    this.expandCollapseStickyHeader(isOpen);
  }

  expandCollapseStickyHeader(isOpen: boolean) {
    const navBarHeight = 68;  // the top navbar height is always 68 px
    const stickyHeaderHeight = this.stickyHeader.nativeElement.querySelector('div').offsetHeight;
    const claimHeaderBoundingRect = this.claimHeader.nativeElement.getBoundingClientRect();

    if (isOpen && claimHeaderBoundingRect.bottom <= navBarHeight) {
      this.stickyHeader.nativeElement.querySelector('div').style.top = (navBarHeight - 1) + 'px';
    } else {
      this.stickyHeader.nativeElement.querySelector('div').style.top = (navBarHeight - stickyHeaderHeight - 1) + 'px';
    }

    this.stickyHeader.nativeElement.querySelector('.btn-sticky-header-container').classList.toggle('show', claimHeaderBoundingRect.bottom <= navBarHeight);
  }

  protected readonly environment = environment;

  setAdjuster(adjuster: AdjusterDto) {
    this.assignedAdjuster = adjuster;
  }
}
